import React, { createContext, useContext, useMemo, useRef } from 'react';
const ScrollContext = /*#__PURE__*/ createContext(undefined);
export const ScrollProvider = ({ children })=>{
    const scrollViewRef = useRef(null);
    const value = useMemo(()=>({
            scrollTo: (element)=>{
                if (element && scrollViewRef.current) {
                    const { top } = element.getBoundingClientRect();
                    if (top < 0 || top > window.innerHeight) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }
            }
        }), []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: scrollViewRef
    }, /*#__PURE__*/ React.createElement(ScrollContext.Provider, {
        value: value
    }, children));
};
export function useScroll() {
    const context = useContext(ScrollContext);
    if (context === undefined) {
        throw new Error('useScroll must be used within a ScrollProvider');
    }
    return context;
}

//# sourceMappingURL=scroll-provider.js.map